import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../Component/Header";
import AdminService from "../Services/apiService";
import { Link, useNavigate } from "react-router-dom";
import TruveyGreenLogo from '../Asset/Images/XSO-White.png';

const VerifyAccount = () => {
    const { ActivationKey } = useParams();
    const [verificationStatus, setVerificationStatus] = useState(null);
    const [Password, setPassword] = useState();
    const [ConfirmPassword, setConfirmPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [error, setError] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [ComplitionStatus, setComplitionStatus] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        if (ActivationKey) {
            const verifyAccount = async () => {
                try {
                    const response = await AdminService.VerifyActivationCode(ActivationKey);
                    if (response) {
                        setVerificationStatus(response.STATUS);
                        console.log(response.RESPONSE);
                    }
                } catch (error) {
                    console.error("Verification failed:", error);
                    setVerificationStatus("ERROR");
                }
            };
            verifyAccount();
        }
    }, [ActivationKey]);

    const handleConfirmPasswordChange = (e) => {
        setConfirmPassword(e.target.value);
        if (e.target.value !== Password) {
            setError("Passwords do not match!");
        } else {
            setError("");
        }
    };
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if (Password !== ConfirmPassword) {
            setError("Passwords do not match!");
        } else {
            const CompleteActivation = async () => {
                try {{
                    const response = await AdminService.CompleteActivation(ActivationKey, Password);
                    if (response) {
                        if(response.STATUS === "SUCCESS"){
                            navigate("/Login")
                        }
                        else{
                            setError(response.MESSAGE)
                        }
                    }
                }} catch (error) {
                    console.error("Verification failed:", error);
                    setVerificationStatus("ERROR");
                }                
            };
            CompleteActivation();
        }
    };
    return (
        <>
            <section className="TruveyBG min-hight99vh py-5">
                <div className="container">
                    <div className="row d-flex align-items-center justify-content-center h-100">
                        <div className="col-md-7 col-lg-6 col-xl-5">
                            <div className="d-none d-md-block text-center" style={{ width: "100%" }}>
                                <Link to="/" className="d-block">
                                    <img src={TruveyGreenLogo} alt="Logo" className="w-50" />
                                </Link>
                            </div>
                        </div>
                        <div
                            className="col-md-5 col-lg-5 col-xl-5 offset-xl-1 p-3 bg-white"
                            style={{
                                borderRadius: "1rem",
                                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                            }}
                        >
                            <div className="p-3">
                                <h2 className="text-center mt-4 fw-bold mb-4">Set Your Password</h2>
                                <form onSubmit={handleSubmit}>
                                    <div className="container mt-5" style={{ minHeight: "45vh" }}>
                                        {verificationStatus === "SUCCESS" ? (
                                            <div>
                                                <label htmlFor="Password" className="form-label">Password</label>
                                                <span className="text-danger"> *</span>
                                                <div className="input-group rounded-pill mb-2">
                                                    <input
                                                        type={showPassword ? 'text' : 'password'}
                                                        id="Password"
                                                        className="form-control rounded-2"
                                                        value={Password}
                                                        maxLength={20}
                                                        onChange={(e) => setPassword(e.target.value)}
                                                        onPaste={(e) => e.preventDefault()}
                                                        required
                                                    />
                                                </div>
                                                <label htmlFor="ConfirmPassword" className="form-label">Confirm Password</label>
                                                <span className="text-danger"> *</span>
                                                <div className="input-group rounded-pill mb-2">
                                                    <input
                                                        type={showConfirmPassword ? "text" : "password"}
                                                        id="ConfirmPassword"
                                                        className="form-control rounded-start-2"
                                                        value={ConfirmPassword}
                                                        maxLength={20}
                                                        onChange={handleConfirmPasswordChange}
                                                        required
                                                    />
                                                    <span
                                                        className="input-group-text border-0"
                                                        onClick={toggleConfirmPasswordVisibility}
                                                        style={{ cursor: "pointer", backgroundColor: "#f0f0f0" }}
                                                    >
                                                        <i className={showConfirmPassword ? "fas fa-eye-slash" : "fas fa-eye"}></i>
                                                    </span>
                                                </div>
                                                {error && <p className="text-danger">{error}</p>}

                                                <div className="text-end">
                                                    <button className="btn btn-custom btn-lg btn-block form-control mt-4 mb-4">
                                                        Complete Activation
                                                    </button>
                                                </div>
                                            </div>
                                        ) : verificationStatus === "Fail" ? (
                                            <div className="alert alert-danger">Invalid activation code</div>
                                        ) : (
                                            <p>Verifying Activation Key...</p>
                                        )}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default VerifyAccount;
